module.exports = __webpack_public_path__ + "img/IZ.8f3b2b92.png";